import React from 'react';
import styles from './StepBreadcrumb.module.css';

export default function StepBreadcrumb({ passos, currentStep, onStepClick }) {
    const activeIndex = passos.findIndex((p) => p.num === currentStep);

    return (
        <div className={styles.wrapper}>
            {passos.map((passo, index) => {
                const concluido = currentStep > passo.num;
                const ativo = currentStep === passo.num;
                const clicavel = typeof onStepClick === 'function' && passo.num <= currentStep && !ativo;
                const mostrarLabel = ativo || Math.abs(index - activeIndex) === 1;

                return (
                    <React.Fragment key={passo.num}>
                        <button
                            type="button"
                            title={!mostrarLabel ? passo.label : undefined}
                            className={`${styles.item} ${ativo || concluido ? styles.itemAtivo : ''} ${clicavel ? styles.itemClicavel : ''}`}
                            onClick={() => clicavel && onStepClick(passo.num)}
                            disabled={!clicavel}
                        >
                            <span className={`${styles.circulo} ${ativo || concluido ? styles.circuloAtivo : ''}`}>
                                {concluido ? <i className="fas fa-check" /> : passo.num}
                            </span>
                            <span className={`${styles.label} ${!mostrarLabel ? styles.labelEscondido : ''}`}>{passo.label}</span>
                        </button>
                        {index < passos.length - 1 && (
                            <i className={`fas fa-chevron-right ${styles.separador}`} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
